// extracted by mini-css-extract-plugin
export default {"content":"style_content__MHtK1","itemName":"style_itemName__9LBa+"};